import { createContext } from 'react';
import ExportControl from '@tilecloud/mbgl-export-control'

const DefaultContext = createContext({
  addControl: () => ExportControl(),

});

export default DefaultContext;
